import React from 'react'

export default {
  type: 'signedurlfileupload',
  LazyComponent: React.lazy(() => import('./signedurlfileupload'))
}
